// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as EnRouteImport } from './routes/en'
import { Route as CasesRouteImport } from './routes/cases'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EnTermsRouteImport } from './routes/en_.terms'
import { Route as EnServicesRouteImport } from './routes/en_.services'
import { Route as EnPrivacyRouteImport } from './routes/en_.privacy'
import { Route as EnPricingRouteImport } from './routes/en_.pricing'
import { Route as EnCasesRouteImport } from './routes/en_.cases'
import { Route as EnBlogRouteImport } from './routes/en_.blog'
import { Route as CaseSlugRouteImport } from './routes/case.$slug'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as CasesSlugRouteImport } from './routes/cases.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as EnCaseSlugRouteImport } from './routes/en_.case.$slug'
import { Route as EnServicesSlugRouteImport } from './routes/en_.services.$slug'
import { Route as EnCasesSlugRouteImport } from './routes/en_.cases.$slug'
import { Route as EnBlogSlugRouteImport } from './routes/en_.blog.$slug'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const EnRoute = EnRouteImport.update({
            id: '/en',path: '/en',getParentRoute: () => rootRouteImport
          })
const CasesRoute = CasesRouteImport.update({
            id: '/cases',path: '/cases',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EnTermsRoute = EnTermsRouteImport.update({
            id: '/en_/terms',path: '/en/terms',getParentRoute: () => rootRouteImport
          })
const EnServicesRoute = EnServicesRouteImport.update({
            id: '/en_/services',path: '/en/services',getParentRoute: () => rootRouteImport
          })
const EnPrivacyRoute = EnPrivacyRouteImport.update({
            id: '/en_/privacy',path: '/en/privacy',getParentRoute: () => rootRouteImport
          })
const EnPricingRoute = EnPricingRouteImport.update({
            id: '/en_/pricing',path: '/en/pricing',getParentRoute: () => rootRouteImport
          })
const EnCasesRoute = EnCasesRouteImport.update({
            id: '/en_/cases',path: '/en/cases',getParentRoute: () => rootRouteImport
          })
const EnBlogRoute = EnBlogRouteImport.update({
            id: '/en_/blog',path: '/en/blog',getParentRoute: () => rootRouteImport
          })
const CaseSlugRoute = CaseSlugRouteImport.update({
            id: '/case/$slug',path: '/case/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })
const CasesSlugRoute = CasesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CasesRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const EnCaseSlugRoute = EnCaseSlugRouteImport.update({
            id: '/en_/case/$slug',path: '/en/case/$slug',getParentRoute: () => rootRouteImport
          })
const EnServicesSlugRoute = EnServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => EnServicesRoute
          })
const EnCasesSlugRoute = EnCasesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => EnCasesRoute
          })
const EnBlogSlugRoute = EnBlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => EnBlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const CasesRouteChildren = {
  CasesSlugRoute: CasesSlugRoute
}

const CasesRouteWithChildren = CasesRoute._addFileChildren(CasesRouteChildren)




const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)




const EnBlogRouteChildren = {
  EnBlogSlugRoute: EnBlogSlugRoute
}

const EnBlogRouteWithChildren = EnBlogRoute._addFileChildren(EnBlogRouteChildren)




const EnCasesRouteChildren = {
  EnCasesSlugRoute: EnCasesSlugRoute
}

const EnCasesRouteWithChildren = EnCasesRoute._addFileChildren(EnCasesRouteChildren)




const EnServicesRouteChildren = {
  EnServicesSlugRoute: EnServicesSlugRoute
}

const EnServicesRouteWithChildren = EnServicesRoute._addFileChildren(EnServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AnalyticsRoute: AnalyticsRoute,BlogRoute: BlogRouteWithChildren,CasesRoute: CasesRouteWithChildren,EnRoute: EnRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ServicesRoute: ServicesRouteWithChildren,TermsRoute: TermsRoute,CaseSlugRoute: CaseSlugRoute,EnBlogRoute: EnBlogRouteWithChildren,EnCasesRoute: EnCasesRouteWithChildren,EnPricingRoute: EnPricingRoute,EnPrivacyRoute: EnPrivacyRoute,EnServicesRoute: EnServicesRouteWithChildren,EnTermsRoute: EnTermsRoute,EnCaseSlugRoute: EnCaseSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)